import type { EngineAirflowConfig } from './types';

// Authored in the engine-stage lab. These are engine-relative, so resizing follows
// the same measured anchor as the aura and engine artwork.
export const ENGINE_AIRFLOW_CONFIG: EngineAirflowConfig = {
  blue: {
    color: '#006eeb',
    opacity: 1,
    brightness: 1.4,
    speed: 0.035,
    width: 0.265,
    distortion: 0.067,
    x: -0.9,
    y: -0.95,
    z: 0.5,
    rotation: -159,
    scaleX: 2.02,
    scaleY: 2.6,
  },
  red: {
    color: '#ff593c',
    opacity: 1,
    brightness: 1.15,
    speed: 0.085,
    width: 0.3,
    distortion: 0.08,
    x: 0.1,
    y: 0.46,
    z: 0.5,
    rotation: -104,
    scaleX: 1.14,
    scaleY: 2.25,
  },
};
